// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "./js/chunks/" + {"596":"404","646":"EventsMap","736":"ProximitySearch","845":"SingleEvent"}[chunkId] + "." + {"596":"f3da46a2","646":"f163b691","736":"5b6fcdf3","845":"171149cb"}[chunkId] + ".js";
};